import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { SettingsService } from '@app/_services/settings.service';

/**
 * A circular favorite indicator that matches the style of MeUserAvatar.
 * Shows a star icon in a circular container with border.
 * Used to indicate favorited items (notes, lists, etc.) in list views.
 *
 * Matches Flutter's MeFavoriteIndicator implementation.
 */
@Component({
  selector: 'app-favorite-indicator',
  standalone: true,
  imports: [CommonModule, SvgComponent],
  template: `
        <app-svg
          name="commonFavblock"
          [color]="ss.theme().color12">
        </app-svg>
  `,
  styles: []
})
export class FavoriteIndicatorComponent {
  /** Radius of the circle (diameter = radius * 2) - default 9 matches MeUserAvatar */
  @Input() radius = 9;

  /** Whether to add a border around the circle (matches MeUserAvatar's addBorder) */
  @Input() addBorder = true;

  ss = inject(SettingsService);

  // Computed properties matching Flutter implementation
  get diameter(): number {
    return this.radius * 2;
  }

  get iconSize(): number {
    return this.diameter * 0.55; // 55% of diameter
  }
}
